import { call, delay, put, takeLatest } from 'redux-saga/effects';
import {
  GET_PATH_NETWORK_RECOMMEND,
  getPathNetworkRecommendAsync,
  GET_PATENT,
  getPatentAsync,
  GET_RECOMMENDED_WORD,
  getRecommendedWordAsync,
  getPathNetworkRecommend2Async,
  GET_PATH_NETWORK_RECOMMEND2,
} from './actions';
import {
  apiGetPathNetworkRecommend,
  responseType,
  apiGetPatent,
  apiGetRecommendedWord,
  apiGetPathNetworkRecommend2,
} from '../../lib/tabAI/api';

function* getPathNetworkRecommendSaga(
  action: ReturnType<typeof getPathNetworkRecommendAsync.request>
) {
  try {
    yield delay(500);
    const token: responseType = yield call(
      apiGetPathNetworkRecommend,
      action.payload
    );
    yield put(getPathNetworkRecommendAsync.success(token));
  } catch (error) {
    yield put(getPathNetworkRecommendAsync.failure(error));
  }
}
function* getPatentSaga(action: ReturnType<typeof getPatentAsync.request>) {
  try {
    yield delay(500);
    const response: responseType = yield call(apiGetPatent, action.payload);
    yield put(getPatentAsync.success(response));
  } catch (error) {
    yield put(getPatentAsync.failure(error));
  }
}

function* getRecommendWordSaga(
  action: ReturnType<typeof getRecommendedWordAsync.request>
) {
  try {
    yield delay(500);
    const response: responseType = yield call(
      apiGetRecommendedWord,
      action.payload
    );
    yield put(getRecommendedWordAsync.success(response));
  } catch (error) {
    yield put(getRecommendedWordAsync.failure(error));
  }
}

function* getPathNetworkRecommend2Saga(
  action: ReturnType<typeof getPathNetworkRecommend2Async.request>
) {
  try {
    yield delay(500);
    const response: responseType = yield call(
      apiGetPathNetworkRecommend2,
      action.payload
    );
    yield put(getPathNetworkRecommend2Async.success(response));
  } catch (error) {
    yield put(getPathNetworkRecommend2Async.failure(error));
  }
}

export default function* tabAISaga() {
  yield takeLatest(GET_PATH_NETWORK_RECOMMEND, getPathNetworkRecommendSaga);
  yield takeLatest(GET_PATH_NETWORK_RECOMMEND2, getPathNetworkRecommend2Saga);
  yield takeLatest(GET_PATENT, getPatentSaga);
  yield takeLatest(GET_RECOMMENDED_WORD, getRecommendWordSaga);
}
